<template>
  <div class="account-settings">
    <Header />
    <div class="settings-main">
      <SettingsNavigation></SettingsNavigation>
      <div class="password">
        <div class="password-main">
          <p class="indentation">
            Your password must be at least eight characters long and should
            contain both letters and numbers. We strongly encourage you to use a
            brand new password and NOT one used on another website account
          </p>
          <div class="input-boxs">
            <div>Current Password</div>
            <input type="text" v-model="form.oldPassword" />
          </div>
          <div class="input-boxs">
            <div>New Password</div>
            <input type="text" v-model="form.newPassword" />
          </div>
          <div class="input-boxs">
            <div>Confirm Password</div>
            <input type="text" v-model="form.confirmedPassword" />
          </div>
          <div :class="['update', { 'update-check': checked }]" @click="submit">
            <div>update</div>
          </div>
        </div>
        <Account></Account>
      </div>
      <AvatarUrl></AvatarUrl>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import SettingsNavigation from "./mycom/settingsNavigation.vue";
import AvatarUrl from "./mycom/avatarUrl.vue";
import Account from "./mycom/account.vue";
import { accountsChangePassword } from "@/api/api.js";
import { Notify } from "vant";
export default {
  components: { Header, Footer, SettingsNavigation, AvatarUrl, Account },
  data() {
    return {
      checked: false,
      form: {
        id: "",
        oldPassword: "",
        newPassword: "",
        confirmedPassword: "",
      },
    };
  },
  methods: {
    submit() {
      this.checked = true;
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = Object.assign(this.form, { id: loginInfo.id });
      accountsChangePassword(params).then((res) => {
        if (res.code === 200) {
          Notify({ type: "success", message: res.errors[0] });
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
  },
};
</script>
<style scoped>
.account-settings {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.settings-main {
  width: calc(100% - 175px);
  padding: 20px 87.5px;
  display: flex;
}
.password {
  width: 100%;
}
.password-main {
  width: 337.5px;
  margin-left: 40.625px;
}
.password-main > p {
  font-size: 10px;
  color: #232323;
  margin-bottom: 15px;
  line-height: 15px;
}
input {
  width: calc(100% - 11.25px);
  height: 21.25px;
  line-height: 21.25px;
  border-radius: 1.25px;
  border: 0.625px solid #dddddd;
  padding-left: 10px;
  font-size: 10px;
}
.input-boxs > div {
  font-size: 10px;
  margin-bottom: 7px;
  margin-top: 12.5px;
}
.explain {
  margin-top: 12.5px;
  font-size: 10px;
  line-height: 15px;
  margin-bottom: 12.5px;
}
.update {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.update > div {
  width: 81.875px;
  height: 22.5px;
  border-radius: 1.5px;
  border: 0.625px solid #2e67ea;
  text-align: center;
  line-height: 22.5px;
  margin-top: 30px;
  color: #2e67ea;
  font-size: 10px;
  cursor: pointer;
}
.update-check > div {
  background-color: #2e67ea;
  color: #fff;
}
.indentation {
  text-indent: 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/password.vue